@let gridData = $gridData();
@let T = gridData.data;

<unity-grid-shared
  gridTitle="Forms"
  [gridData]="gridData"
  [gridError]="$gridError()"
  [gridLoading]="$gridLoading()"
  [defaultSort]="defaultSort"
  (dataQueryEvent)="onDataQuery($event)">
  <kendo-grid-column field="form_schedule.type_name" title="Form">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-link-gridcell-shared
        [displayText]="item.form_schedule.type_name"
        [link]="['/agreement', item.agreement.id, 'form-instance', item.id]" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="open_date" title="Open Date" filter="date">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      {{ item.open_date | dateTimezone }}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="due_date" title="Due Date" filter="date">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      {{ item.due_date ? (item.due_date | dateTimezone) : 'N/A' }}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="form_response" title="Has Response?">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      {{ item.form_response !== null ? 'Yes' : 'No' }}
    </ng-template>
  </kendo-grid-column>
</unity-grid-shared>
